import { lazily } from '@mkmp/core'
import { BasicLayout } from '@/features/layout'

const { UserCenter, UserPerfect, UserBind } = lazily(() => import('@/features/user'))

/**
 * 用户相关页面
 */
export default [
  {
    id: Symbol('user'),
    path: 'user',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <UserCenter />,
        handle: {
          code: 'user'
        }
      }
    ]
  },
  {
    id: Symbol('perfect'),
    path: 'perfect',
    element: <UserPerfect />
  },
  {
    id: Symbol('bind'),
    path: 'bind',
    element: <UserBind />
  }
]
